'use client';

import HeaderMenu from './HeaderMenu';
import Image from 'next/image';
import Link from 'next/link';
import Navbar from './Navbar';

interface NavItem {
  label: string;
  href: string;
}

interface HeaderProps {
  navItems: NavItem[];
  defaultRoute: string;
}

export default function Header({ navItems, defaultRoute }: HeaderProps) {
  return (
    <header
      className="fixed top-0 left-0 w-full z-50 bg-base-100"
      role="banner"
    >
      <nav
        className="container mx-auto flex justify-between items-center p-4"
        role="navigation"
      >
        <Link
          href={defaultRoute}
          className="flex items-center gap-2 text-xl font-extrabold brand-font"
        >
          <Image
            src="/images/logoBlue.svg"
            alt="Brand Logo"
            width={40}
            height={40}
          />
          <span>OMKODE</span>
        </Link>
        <Navbar items={navItems} defaultRoute={defaultRoute} />
        <div className="flex items-center gap-4">
          <Link className="btn btn-primary" href={'contact-us'}>
            Contact Us
          </Link>
          <HeaderMenu navItems={navItems} defaultRoute={defaultRoute} />
        </div>
      </nav>
    </header>
  );
}
